import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import authService from '../utils/auth';
import Footer from '../components/Footer';
import './LoginPage.css';

// 管理员 / 运营 / 财务进管理后台（由首页按权限再分到第一个可用页面），其余进销售后台
const homeOf = (role) => (['admin', 'operations', 'finance'].includes(role) ? '/' : '/sales');

function LoginPage() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // 检查是否已经登录
  useEffect(() => {
    if (authService.isAuthenticated()) {
      navigate(homeOf(authService.getUserInfo()?.role), { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      const { username, password } = values;

      const result = await authService.login(username, password);

      message.success('登录成功！');

      // 根据角色跳转
      const from = location.state?.from?.pathname || homeOf(result.user.role);

      navigate(from, { replace: true });
    } catch (error) {
      message.error(error.message || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Card className="login-card" title="出团管理系统">
        <Form
          form={form}
          name="login"
          onFinish={handleSubmit}
          size="large"
          className="login-form"
        >
          <Form.Item
            name="username"
            rules={[
              { required: true, message: '请输入用户名' },
              { min: 3, message: '用户名至少3个字符' }
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="用户名"
              autoComplete="username"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: '请输入密码' },
              { min: 6, message: '密码长度至少6位' }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="密码"
              autoComplete="current-password"
              onPressEnter={() => form.submit()}
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-button"
              loading={loading}
              block
            >
              登录
            </Button>
          </Form.Item>

          <div style={{ textAlign: 'right', marginTop: -8, marginBottom: 8 }}>
            <Link to="/forgot-password" style={{ fontSize: 13 }}>忘记密码？</Link>
          </div>
        </Form>

        <Footer className="card-footer" centered={true} />
      </Card>
    </div>
  );
}

export default LoginPage;